module.exports = __webpack_public_path__ + "img/orb_yellow_flower.b57780c0.png";